import React, { useState, useEffect, useRef } from "react";
import "./DashboardSummary.css";

import SummaryCard from "../../components/DashboardSummary/SummaryCard";
import { useGlobal } from "../../contexts/GlobalContext";

function DashboardSummary() {
  const { user } = useGlobal();
  return (
    <div className="employee-dashboard-summary">
      <p>Hello {user?.FirstName}! 👋</p>
      <h2>Good Morning</h2>
      <div className="employee-dashboard-summary-card">
        <SummaryCard type={"employee"} text={"Number of Employee"} />
        <SummaryCard type={"on-leave"} text={"On Leave"} />
      </div>
      <div className="employee-dashboard-summary-card">
        <SummaryCard type={"new-employee"} text={"New Joinee"} />
        <SummaryCard type={"upcoming-holiday"} text={"Upcoming Holiday"} />
      </div>
    </div>
  );
}

export default DashboardSummary;
